module.exports = __webpack_public_path__ + "img/my-profile.70bfdcf6.svg";